<template>
    <div>
        <h2 class="title">Eligibility Form Report</h2>

       
        <div class="notification is-warning" v-if="loading == true">
            Loading members ...
        </div>
        <div class="notification is-danger" v-if="loading == false && members.length == 0">
            No active members can be found that require this check
        </div>

        <table class="table is-fullwidth is-hoverable" v-if="loading == false && this.members.length > 0">
            <thead>
                <tr>
                    <th width="50"></th>
                    <th>Forename</th>
                    <th>Surname</th>
                    <th>Completed Date</th>
                    <th>Expiry Date</th>
                    <th>Last Reminder Sent</th>
                    <th width="110">&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in this.members" :key="row.id" :class="{'has-background-danger-dark' : row.blocked==1, 'has-text-white' : row.blocked==1}">
                    <td><router-link :to="'/members/' + row.id + '?tab=personal'" target="_blank"><button class="button is-small is-link" >View</button></router-link></td>
                    <td>{{ row.forename }}</td>
                    <td>{{ row.surname}}</td>
                    <td>{{ row.eligibility_form_date }}</td>
                    <td>
                        <span class="tag is-warning" v-if="row.eligibility_form_date == '' || row.eligibility_form_date == null">Not Set</span>
                        <span class="tag is-danger" v-else-if="checkDate(row.eligibility_expiry_date)">{{ row.eligibility_expiry_date }}</span>
                        <span class="tag is-success" v-else>{{ row.eligibility_expiry_date }}</span>
                        </td>
                        <td>{{  row.last_eligibility_reminder_date }}</td>
                    <td ><button class="button is-small is-link" :class="{'is-success' : row.reminder_sent == 1}" :disabled="working==true" @click="sendReminder(row)">Send Reminder</button></td>
                    
                </tr>
                
                
            </tbody>
            
        </table>

       
    </div>
</template>

<script>
import MemberService from '@/services/MemberService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

//import MemberGradeTags from '@/components/Generic/MemberGradeTags.vue';

export default {
    
      name: 'MembersDashboard',
        mixins: [MemberMixin],
        components: {
            //MemberGradeTags
        },
        data: function () {
            return {
                   search: '',
                   members: [],
                   loading: false,
                  working:false,
                   showModal: false,
                   order_by: "eligibility_form_date ASC"
            }
        },
        methods: {
            checkDate(checkDate) {
                if(checkDate != '' && checkDate != null)
                {
                    const sqlDateParts = checkDate.split('-');
                    
                    const sqlTimestamp = new Date(sqlDateParts[0], sqlDateParts[1] - 1, sqlDateParts[2]);
                    const targetTimestamp = new Date();

                    let isBeforeTargetDate = sqlTimestamp < targetTimestamp;

                    return isBeforeTargetDate
                }
                else {
                    return false
                }
                
            },
            async sendReminder(row) {
                this.working = true

                if(confirm('Are you sure you want to email this member ?'))
                {
                    var formdata = { 
                        
                        
                    }; 

                    

                    MemberService.sendEligibilityReminder(this.accessToken, formdata, row.id)
                    .then( () => {
                            row.reminder_sent = 1
                            alert("Reminder sent")
                            this.working = false
                        }
                    )
                    .catch((error) => { 
                        if (error.response.status == 400) {
                            alert(error.response.data.error)
                        } 
                        else{
                            alert(error.message)
                        } 
                        this.working=false;
                    })
                    
                    
                }
                else {
                    this.working = false
                    return false
                }
               
            },
            
            
        
         
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getSupportWorkers(this.order_by)
            });
        
        },
    }
</script>